import { dateProvider } from '@utils';
import { create as createStore } from 'zustand';
import { persist } from 'zustand/middleware';

import { useLastConnection } from '@/store';
import { useProfile } from '@/store/profile/useProfile';

interface INewDashboardStore {
  acceptedUsers: string[];
  addAcceptedUser: (userId: string) => void;
}

export const useNewDashboardStore = createStore<INewDashboardStore>()(
  persist(
    (set, get) => ({
      acceptedUsers: [],
      addAcceptedUser: (userId: string) => {
        const { acceptedUsers } = get();
        if (!acceptedUsers.includes(userId)) {
          set({ acceptedUsers: [...acceptedUsers, userId] });
        }
      }
    }),
    {
      name: 'newDashboardAcceptedUsers'
    }
  )
);

const RELEASE_DATE = dateProvider.zonedTimeToUtc({
  dateTime: '2025-08-19T00:00:00',
  timeZone: 'Europe/Madrid'
});

export const useUserKnowNewDashboard = () => {
  const { profile } = useProfile();
  const userId = profile?._id;

  const { lastConnection, isLoading: isLoadingLastConnection } = useLastConnection(userId ?? '');

  const { acceptedUsers, addAcceptedUser } = useNewDashboardStore();

  const isLegacyUser = Boolean(
    lastConnection &&
      new Date(lastConnection.closeConnectionAt ?? lastConnection.createdAt ?? Date.now()) <
        RELEASE_DATE
  );

  const mustShowModal = Boolean(userId && isLegacyUser && !acceptedUsers.includes(userId));

  return {
    mustShowModal: mustShowModal,
    addAcceptedUser,
    isLoading: isLoadingLastConnection
  };
};
